
























































import { config } from "@/config";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class extends Vue {
  public dialog = false;
  public drawer = null;
  public version = config.version;
  public items = [
    { icon: "home", text: "Home", name: "superadmin_home" },
    { icon: "fastfood", text: "Manage Categories", name: "categories" },
    { icon: "settings", text: "Manage Restaurants", name: "restaurants" },
    {
      icon: "show_chart",
      text: "Reports",
      subLinks: [
        {
          text: "Restaurants Sales Report",
          name: "restaurants-sales-report"
        }
      ]
    }
  ];
}
